import React, { useContext } from 'react';
import { DebugContext } from '../../contexts/DebugContext';
import { IInteriorProduct } from '../../models/IChainInfo';
import { IInteriorItem, InteriorProductType } from '../../services/WebApiClient';
import { FrontPosConverter } from '../../util/PosConverter';
import { EditorContext } from '../EditorCommon/EditorContext';
import { InteriorDragContext } from './InteriorImageDragContext';


export function InteriorImageItem(props: {
    item: IInteriorItem;
    product: IInteriorProduct;
}) {

    const ec = useContext(EditorContext);
    const dragContext = useContext(InteriorDragContext);
    const debugContext = useContext(DebugContext);

    const {
        item,
        product
    } = { ...props };

    const material = product.materials.find(m => m.interiorMaterialId === item.interiorMaterialId);
    const imageUrl = material?.drawingPath
        ?? product.textureUrl
        ?? undefined;

    // don't display item if user is dragging it
    if (dragContext.info?.item && dragContext.info.isDragging) {
        if (dragContext.info.item.index === item.index) {
            return null; 
        }
    }

    const convert = new FrontPosConverter(ec.cabinet.height!);

    const displayBottomPiece = product.productType === InteriorProductType.TopAndBottom;
    const bottomPiece = displayBottomPiece && (
        <g>
            <image
                className="interior-item placed movable"
                onMouseDown={evt => itemMouseDown(evt, item, product)}
                {...convert.pos({ ...item.position, y: 0 }, item.size)}
                {...convert.size(item.size)}
                transform={item.isFlipped ? convert.getFlipTransformString(item) : ''}
                xlinkHref={imageUrl}
                preserveAspectRatio="none"
            />
            {debugContext.value.displayExtendedProductInfo && (
                <rect
                    {...convert.pos({ ...item.position, y: 0 }, item.size)}
                    {...convert.size(item.size)}
                    style={{
                        fill: "none",
                        strokeWidth: "2px",
                        stroke: "red"
                    }}
                />
            )}
        </g>
    );


    function itemMouseDown(
        evt: React.MouseEvent,
        item: IInteriorItem,
        product: IInteriorProduct) {
        evt.preventDefault();
        evt.stopPropagation();

        dragContext.setInfo({
            item,
            isDragging: false,
            initialCoords: { x: evt.clientX, y: evt.clientY },
            subGroup: product.productSubGroup,
            mouseOffset: { x: 0, y: 0 }
        });
    }

    return (
        <g>
            <image
                className="interior-item placed movable"
                onMouseDown={evt => itemMouseDown(evt, item, product)}
                {...convert.pos(item.position, item.size)}
                {...convert.size(item.size)}
                transform={item.isFlipped ? convert.getFlipTransformString(item) : ''}
                xlinkHref={imageUrl}
                preserveAspectRatio="none"
            />

            {bottomPiece}

            {debugContext.value.displayExtendedProductInfo && (
                <rect
                    {...convert.pos(item.position, item.size)}
                    {...convert.size(item.size)}
                    style={{
                        fill: "none",
                        strokeWidth: "2px",
                        stroke: "red"
                    }}
                />
            )}
        </g>
    );
}
